import { useMatches } from 'react-router';

export function useLastHandle(): Record<string, unknown> | null {
  const matches = useMatches();
  return useMemo(() => {
    return matches.at(-1)?.handle as any;
  }, [matches]);
}

export function useMergedHandle(): Record<string, unknown> | null {
  const matches = useMatches();

  const mergedHandle = useMemo(() => {
    return matches.reduce((acc, curr) => {
      return { ...acc, ...(curr.handle as Record<string, unknown>) };
    }, {});
  }, [matches]);

  return mergedHandle;
}
